import api from "../../shared/AxiosConfig";

/** Admin: aktif dönem + başvuru açık/kapalı durumu */
export async function fetchApplicationSettings() {
    const res = await api.get("/application/settings");
    return res.data?.data ?? null;
}

/** Aktif (varsayılan) dönemde public başvuru formunu aç/kapat */
export async function patchApplicationSettings(isApplicationOpen) {
    const res = await api.patch("/application/settings", { isApplicationOpen });
    return res.data;
}

/** Public (auth yok) — landing için aynı özet */
export async function fetchActiveApplicationTerm() {
    const res = await api.get("/application/active-term");
    return res.data?.data ?? null;
}
